import { registerBlockType } from '@wordpress/blocks';
import Edit from './edit';
import Save from './save';
import metadata from './block.json';
import { info } from '@wordpress/icons';
import icon from './icon';

registerBlockType( metadata.name, {
	edit: Edit,
	save: Save,
	icon: icon,
} );
